export function truncateMiddle(str: string, { length = 30 }: { length?: number } = {}) {
  if (str.length <= length) {
    return str;
  }
  const sliceLength = Math.floor((length - 1) / 2);
  return str.slice(0, sliceLength) + '…' + str.slice(-sliceLength);
}
